import { InputAdornment, TextField } from "@mui/material";
import {
    ReactElement,
    HTMLAttributes,
    useState,
    useEffect
} from "react";
import { FaStarOfLife } from "react-icons/fa";
import { Cancel } from "../../assets";
import { numberRegexp } from "../../core/regexp";
import { numberWithCommas } from "../../core/utils";
interface Props extends HTMLAttributes<HTMLElement> {
    value: string | number;
    title?: string,
    onChange?: any;
    name?:string;
    myStyle?: string;
    icon?: ReactElement;
    customFocus?: any;
    lable?: string;
    disabled?: boolean;
    error?: string;
    type?: string;
    emptyState?: any;
    max?: string;
    placeholder?: string;
    endAdornment?: any;
    isRequired?: boolean;
    hideEndAdornment?: boolean;
    iconBorder?: boolean;
    hasNotice?: boolean;
    hasComma?: boolean;
    preText?:string;
    rows?:number;
    multiline?:boolean;


}

export function Input({ value, onChange, name, title, myStyle, icon, customFocus, lable, disabled, error, type, emptyState, max, placeholder, iconBorder, endAdornment, isRequired, hideEndAdornment,
    rows, multiline, preText, hasComma }: Props, props: any): ReactElement {
    // let textInput : any = useRef(null);
    const [shrink, setShrink] = useState(false);

    const setFoces = () => {
        setShrink(true)
        // customFocus && customFocus()
    }

    useEffect(() => {
        if (value === "") setShrink(false)
        if (value !== "")
            // textInput.current.focus();
            setFoces();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [value]);
    const handleOnChange = (e: any) => {
        if (type === "number") {
            // if (e.target.value === "" || numberRegexp.test(e.target.value)) {
            //     onChange(e)
            // }
            if (hasComma) {
                var val = e.target.value.replace(
                    /,/g,
                    ""
                );
                const re = /^[0-9\b]+$/;
                if (val === "" || re.test(val)) {
                    onChange(val)
                }
            } else {
                if (e.target.value === "" || numberRegexp.test(e.target.value)) {
                onChange(e)
            }
            }
           
        } else {
            onChange(e)
        }
    }
    const showValue = (e: any) => {
        if (type === "number" && hasComma) {
            if (e !== "") {
                return numberWithCommas(e)
            }
        } else {
            return e
        }
    }
    return (

        <div className={`${myStyle && myStyle} custom-input${multiline ? " custom-input-multiline" : ""}`} >
            {lable &&

                <>

                    <label className="custom-input-lable">
                        {isRequired && <FaStarOfLife />}  {lable} 
                    </label>



                </>
            }
            <TextField
                className="input"

                // error={error ? true : false}
                onFocus={() => customFocus ? customFocus() : setFoces()}
                value={showValue(value)}
                // onChange={(e)=>onChange(e.target.value)}
                onChange={handleOnChange}
                disabled={disabled}
                // inputRef={textInput} 
                onBlur={(e) => setShrink(!!e.target.value)}
                InputLabelProps={{ sx: icon ? { ml: 4.5 } : null, shrink }}
                sx={(theme) => ({
                    "& .MuiOutlinedInput-notchedOutline": {
                        px: icon ? 5.5 : ""
                    }
                })}
                multiline={multiline}
                rows={rows}
                // onInput={(e:any) => {
                //     e.target.value = Math.max(0, parseInt(e.target.value)).toString().slice(0, 12);
                //   }}
                //   InputProps={{ inputProps: { min: "0", max: "10", step: "1" } }}
                inputProps={{
                    maxLength: max ? max : "255",
                }}
                type="string"
                label={title && title}
                name={name}
                placeholder={placeholder && placeholder}

                InputProps={{
                    startAdornment: icon ? (
                        <InputAdornment position="start" >
                            {icon}
                            {iconBorder &&
                                <div className="custom-input-icon-border">
                                </div>
                            }
                        </InputAdornment>
                    ) : null,
                    endAdornment: 
                    // (value && !hideEndAdornment) ? (
                    //     <InputAdornment position="end" onClick={emptyState} className="custom-input-cancel">
                    //         {<Cancel width="10px" color="#0074BA" myStyle="cursor-pointer" />}
                    //     </InputAdornment>
                    // ) :
                     endAdornment ? (<span className="d-flex align-items-center">
                    {preText && <span className="ps-2"> {preText}</span> }  {endAdornment}
                    </span>
                    ) : ""
                }}
                variant="outlined"
            />
            {error &&
                <label className={`${multiline && "mt-85"} custom-input-error`}>
                    {error}
                </label>
            }
        </div>

    );
}

export default Input;